import { createSlice } from "@reduxjs/toolkit";

export interface FilterState {
  eventsType: any;
  location: any;
  currentPage: any;
  school: any;
  age: any;
  category: any;
  eventsMode: any;
  gender: any;
  zoneSearchBox: any;
  eventSearchBox: any;
  title: any;
  registrationsOpen: boolean;
  privateEvents: boolean;
  grade?: any;
  school_id: any;
  venue_address: any;
}

const initialState: FilterState = {
  eventsType: [],
  location: "",
  currentPage: 1,
  school: "",
  age: "",
  eventsMode: "",
  category: "",
  gender: "",
  zoneSearchBox: "",
  eventSearchBox: "",
  title: "",
  registrationsOpen: false,
  privateEvents: false,
  grade: "",
  school_id: [],
  venue_address: "",
};

const leaderboardFilterSlice = createSlice({
  name: "leaderboardFilter",
  initialState,
  reducers: {
    addleaderboardFilter: (state, action) => {
      return (state = action.payload);
    },
    loadFilterFromStorage: (state, action) => {
      return (state = action.payload);
    },
    clearFilter: (state) => {
      return (state = initialState);
    },
  },
});

export const { addleaderboardFilter, loadFilterFromStorage, clearFilter } =
  leaderboardFilterSlice.actions;

export const leaderboardFilterItems = (state: {
  leaderboardFilter: FilterState;
}) => state.leaderboardFilter;

export default leaderboardFilterSlice.reducer;
